import { render } from "./BoatBookingCard.vue?vue&type=template&id=7bf5af61&scoped=true&ts=true"
import script from "./BoatBookingCard.vue?vue&type=script&lang=ts"
export * from "./BoatBookingCard.vue?vue&type=script&lang=ts"

import "./BoatBookingCard.vue?vue&type=style&index=0&id=7bf5af61&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf5af61"]])

export default __exports__